import { Label, PolarGrid, PolarRadiusAxis, RadialBar, RadialBarChart } from 'recharts';

import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart/base';
import { ChartRadialProps } from '@/types/charts';
import { cn } from '@/utils/styles';

const ChartRadial = ({ data, settings, chartConfig, className }: ChartRadialProps) => {
  const { chart, legend } = settings;
  const { valuePrefix, valueSuffix, tooltipSubHeading, hideTooltipLabel, labelFormatter } = settings.tooltip ?? {};

  return (
    <ChartContainer config={chartConfig} className={cn('max-h-[200px] min-h-[200px] w-full', className)}>
      <RadialBarChart data={data} {...chart}>
        <PolarGrid {...settings.polarGrid} />

        {!settings.tooltip?.hide && (
          <ChartTooltip
            cursor={settings.tooltip?.cursor}
            content={
              <ChartTooltipContent
                valuePrefix={valuePrefix}
                valueSuffix={valueSuffix}
                tooltipSubHeading={tooltipSubHeading}
                hideLabel={hideTooltipLabel}
                labelFormatter={labelFormatter}
                nameKey={settings.tooltip?.nameKey}
              />
            }
          />
        )}

        <RadialBar dataKey={settings.radialBar?.dataKey || ''} {...settings.radialBar} />

        {settings.innerStats && settings.innerStats.stat && (
          <PolarRadiusAxis {...settings.polarRadiusAxis}>
            <Label
              // eslint-disable-next-line react/no-unstable-nested-components
              content={({ viewBox }) => {
                if (viewBox && 'cx' in viewBox && 'cy' in viewBox) {
                  return (
                    <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle" dominantBaseline="middle">
                      <tspan x={viewBox.cx} y={viewBox.cy} className="fill-text-primary text-4xl font-bold">
                        {settings?.innerStats?.stat}
                      </tspan>
                      {settings?.innerStats?.label && (
                        <tspan x={viewBox.cx} y={(viewBox.cy || 0) + 24} className="fill-text-secondary text-baseSm">
                          {settings?.innerStats?.label}
                        </tspan>
                      )}
                    </text>
                  );
                }
                return null;
              }}
            />
          </PolarRadiusAxis>
        )}

        {!legend?.hide && <ChartLegend content={<ChartLegendContent textSize={legend?.textSize} />} />}
      </RadialBarChart>
    </ChartContainer>
  );
};

export { ChartRadial };
